var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.app.native && _vm.$store.state.app.version)?_c('p',{staticClass:"app-version-box"},[_vm._v(" "+_vm._s(_vm.$t('application.version', {version: _vm.$store.state.app.version}))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }